<card-layout
  [title]="itemTeam?.title ?? '-'"
  [description]="itemTeam?.parms?.desc"
  [image]="itemTeam?.assetUrl"
  [pathAbsolute]="true"
  [path]="['/team', itemTeam?.team?.name || '']"
  (clicked)="onClick()"
  [wrap]="wrap"
></card-layout>
